import QuestionnaireChoiceStep from "pages/application/templates/shared/QuestionnaireChoiceStep";
import { visibleAttributionSources } from "pages/application/templates/SingleChoice";
import { getStepData } from "pages/application/question/questionSlice";
import { useSelector } from "react-redux";
import "../SingleChoice/single-choice.scss";

const SingleChoiceWithFollowUp = () => {
  const stepData = useSelector(getStepData);
  const stepActions = visibleAttributionSources(
    [...stepData.nextStepActions].sort((a, b) => a.presentationOrder - b.presentationOrder)
  );

  return (
    <div className="single-choice single-choice-dropdown">
      <QuestionnaireChoiceStep
        stepActions={stepActions}
        stepCode={stepData.stepCodeText}
        stepLabel={stepData.label}
        skipAction={stepData.skipAction}
        disclaimer={stepData.disclaimer}
        showAsDropdown
        followUpInputs={stepData.inputs}
      />
    </div>
  );
};

export default SingleChoiceWithFollowUp;
